import { QuestionType } from "api/landlord-surveys/types/questions";
import { Select } from "shared/components";
import { Card } from "shared/components/Card";
import { SwitchSize, Switch } from "shared/components/forms/Switch";
import {
  useSurveyStore,
  selectActiveQuestion
} from "views/landlord-surveys-id/store";

const options = [
  {
    label: "Plain text",
    value: QuestionType.LONG_TEXT
  },
  {
    label: "Yes/No",
    value: QuestionType.YES_NO
  },
  {
    label: "Multiple options",
    value: QuestionType.CHECKBOX_MULTI
  },
  {
    label: "Single option",
    value: QuestionType.RADIO_GROUP
  },
  {
    label: "Date",
    value: QuestionType.DATE
  },
  {
    label: "File upload",
    value: QuestionType.FILE_SINGLE
  }
];

export const WidgetConfiguration = () => {
  const activeQuestion = useSurveyStore(selectActiveQuestion);
  const updateActiveQuestion = useSurveyStore(
    (state) => state.updateActiveQuestion
  );

  return (
    <Card className="max-w-[300px] w-full shrink-0 h-fit p-6">
      <Select
        className="mb-6"
        hideOptional
        label="Answer type"
        id="question-type"
        value={activeQuestion?.type}
        options={options}
        onChange={(e) => {
          const type = e.target.value as QuestionType;
          const needsOptions =
            type === QuestionType.CHECKBOX_MULTI ||
            type === QuestionType.RADIO_GROUP ||
            type === QuestionType.YES_NO;

          updateActiveQuestion((prev) => {
            const hasOptions = "options" in prev && prev.options;

            if (needsOptions) {
              const defaultOptions: [string, ...string[]] =
                type === QuestionType.YES_NO
                  ? ["Yes", "No"]
                  : ["Option 1", "Option 2", "Option 3"];

              return {
                ...prev,
                type,
                options: hasOptions ? prev.options : defaultOptions
              };
            }

            return {
              id: prev.id,
              internal_id: prev.internal_id,
              index: prev.index,
              question: prev.question,
              description: prev.description,
              is_required: prev.is_required,
              type
            };
          });
        }}
      />

      <Switch
        label="Required"
        size={SwitchSize.SM}
        checked={Boolean(activeQuestion?.is_required)}
        onChange={(v) => {
          if (!activeQuestion) return;
          updateActiveQuestion({ ...activeQuestion, is_required: v });
        }}
      />
    </Card>
  );
};
